import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {ProductFaceDefaultPlacement} from "./product-face-default-placement.model";
import {environment} from "../../../environments/environment";

@Injectable({providedIn: 'root'})
export class ProductFaceDefaultPlacementService {
    constructor(private http: HttpClient) {
    }

    getAll(): Observable<ProductFaceDefaultPlacement[]> {
        return this.http.get<ProductFaceDefaultPlacement[]>(
            `${environment.rootUrl}/product-face-default-placement/get-all/`
        );
    }
}
